import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { Box, Stack, Tooltip, useTheme } from '@mui/material';

import usePrimaryNavStore from '@/components/shared/PrimaryNavDrawer/PrimaryNavStore';

const PrimaryNavLock = () => {
  const { isDrawerOpen, isDrawerLocked, setIsDrawerLocked } =
    usePrimaryNavStore();
  const iconRotation = isDrawerLocked ? 180 : 0;
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        justifyItems: 'end',
        justifyContent: 'flex-end',
        flexGrow: 1,
        opacity: isDrawerOpen ? 1 : 0,
        visibility: isDrawerOpen ? 'visible' : 'hidden',
        transition: `
          opacity ${theme.transitions.duration.complex}ms ${theme.transitions.easing.easeInOut},
          visibility ${theme.transitions.duration.complex}ms ${theme.transitions.easing.easeInOut}
        `,
        position: 'relative',
        width: '100%',
        p: 0,
        mr: isDrawerOpen ? 0.5 : 3,
      }}
    >
      <Box
        sx={{
          height: 32,
          width: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: -0.5,
        }}
      >
        <Tooltip
          title={isDrawerLocked ? 'Unlock' : 'Lock'}
          placement="top-start"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [-15, 0],
                  },
                },
              ],
            },
          }}
        >
          <KeyboardDoubleArrowLeftIcon
            onClick={() => setIsDrawerLocked(!isDrawerLocked)}
            sx={{
              color: 'neutral400',
              cursor: 'pointer',
              '&:hover': { color: 'white' },
              transform: `rotate(${iconRotation}deg)`,
              transformOrigin: 'center',
              transition: `
                transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)
              `,
            }}
            className="keyboard-arrow-icon"
          />
        </Tooltip>
      </Box>
    </Stack>
  );
};

export default PrimaryNavLock;
